"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDropFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M11.419 3.297a.722.722 0 01.95-.195c.08.049.16.122.212.195.37.514.766 1.076 1.215 1.688C15.883 7.82 19 12.075 19 14.52c0 1.785-.793 3.4-2.06 4.573A7.257 7.257 0 0112 21a7.355 7.355 0 01-4.94-1.883C5.792 17.944 5 16.33 5 14.545c0-2.445 3.117-6.724 5.204-9.56.475-.636.871-1.174 1.215-1.688zM15.999 14c-.998 0-.998 1-.998 1A2.004 2.004 0 0113 17s-1 .005-1 1.002S13 19 13 19a4 4 0 004-4s-.001-1-1-1z' }))); };
exports.default = SvgDropFilled;
//# sourceMappingURL=DropFilled.js.map